import { requestApi } from '@/api/apiV2.0'
import service from '@/utils/request'

export const useDataApi = async (url: string) => {
	const { data } = await service.get(url)

	return data
}

export const apiRequest = async (method: string, url?: string, data?: any) => {
	// 创建请求配置对象

	return service({
		method,
		url,
		// 对于 GET 请求，data 应该放在 params 中
		params: method === 'GET' || method === 'get' ? data : undefined,
		// 对于 POST、PUT 请求，data 应该放在 data 中
		data: method !== 'GET' ? data : undefined
	})
}
